// WARNING: DO NOT EDIT. This file is automatically generated by CDP Build. It will be overwritten.

export const cdpenv = {
		"TerminalApi":"https://canary-terminal.surecanpay-uat.com/",
	"TennantAPI":"https://canary-tenant.surecanpay-uat.com/",
	"FilesURL":"https://canary-files.surecanpay-uat.com/settlement",

};
